import { render, staticRenderFns } from "./ModalOrderDetailMarkAsPaid.vue?vue&type=template&id=2d377059&"
import script from "./ModalOrderDetailMarkAsPaid.vue?vue&type=script&lang=js&"
export * from "./ModalOrderDetailMarkAsPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports